export default "__VITE_ASSET__90346b89__"